export default __webpack_public_path__ + "static/media/ghostwalk.1be2be9c.mpeg";